// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateProfileClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitUpdateProfileClientApi = createAsyncThunk("hitUpdateProfileClientApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + updateProfileClient;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const UpdateProfileClientSlice = createSlice({
  name: "updateProfileClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateProfileClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateProfileClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateProfileClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateProfileClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateProfileClientData } = UpdateProfileClientSlice.actions;
export default UpdateProfileClientSlice.reducer;
